import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Cliente } from "../cliente";
import { ConfigService } from './../../services/config.service';

@Injectable({ providedIn: 'root' })
export class ClienteService {

	constructor(
		private httpClient: HttpClient,
		private configService: ConfigService
	) {}

	getFiliais(): Observable<Cliente[]> {
		return this.httpClient.get<Cliente[]>(
			this.configService.getEndereco() + '/cotacao/getFiliais',
			{
				headers: this.configService.getHeaders()				
			}
		)
	}
}